export class AppSettings {
  public static CLIS_URL = 'https://clis.ircnet.com/';
  public static INFOBOT_API_URL = 'https://bot.ircnet.info/api';
}
